// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sb-alert{font-size:14px;padding:10px 15px;line-height:18px;position:relative;margin-bottom:1rem;border:1px solid transparent;border-radius:4px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.sb-alert.info{color:#383d41;background-color:#cfd8dc;border-color:#cfd8dc}.sb-alert .content{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}", ""]);
// Exports
module.exports = exports;
